import React from 'react';
import { BookOpen, GraduationCap } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Card, CardContent } from './ui/card';

const Teaching = () => {
  const iitGuwahatiCourses = [
    { code: 'ME 663', name: 'Mesh Reduction Methods and XFEM', years: 'Proposed and accepted' },
    { code: 'ME 501', name: 'Advanced Engineering Mathematics', years: 'July 2022, 2023' },
    { code: 'ME 326', name: 'Mechanical Engineering Lab-IV: Tribology', years: 'Jan 2022, 2023' },
    { code: 'ME 223', name: 'Solid Mechanics – II', years: 'Jan 2022, 2023' },
    { code: 'ME 216', name: 'Mechanical Engineering Lab-I: Strength of Materials', years: 'July 2021-2023' },
    { code: 'ME 101', name: 'Engineering Mechanics', years: 'Jan 2018-2020, March 2021' },
    { code: 'ME 212', name: 'Solid Mechanics-I', years: 'July 2017-2019, Sep 2020-2021' },
    { code: 'ME 607', name: 'Introduction to Composite Materials', years: 'Jan 2018' },
    { code: 'CE 101', name: 'Engineering Drawing', years: 'July 2017, 2018, 2019' },
  ];

  const iitPalakkadCourses = [
    { code: 'ME5021', name: 'Solid Mechanics and Simulation Laboratory', years: 'Aug 2025, 2026' },
    { code: 'ME5501', name: 'Finite Element Methods', years: 'Aug 2025, 2026' },
    { code: 'ME5635', name: 'Mechanics of Composite Materials', years: 'Jan 2025, 2026' },
    { code: 'ME5011', name: 'Mathematics for Engineers', years: 'July 2024' },
    { code: 'ME1130', name: 'Engineering Drawing', years: 'July 2024' },
    { code: 'ME3522', name: 'Introduction to Finite Element Methods', years: 'Jan 2024' },
  ];

  return (
    <section id="teaching" className="section-container bg-slate-50">
      <h2 className="section-title">Teaching Experience</h2>
      
      <div className="w-full">
        <Tabs defaultValue="palakkad" className="w-full">
          <TabsList className="grid w-full grid-cols-2 mb-8">
            <TabsTrigger value="palakkad">IIT Palakkad</TabsTrigger>
            <TabsTrigger value="guwahati">IIT Guwahati</TabsTrigger>
          </TabsList>

          <TabsContent value="palakkad">
            <div className="mb-6">
              <h3 className="text-2xl font-bold text-[#1e3a8a] mb-4">Current Position (Dec 2023 - Present)</h3>
              <p className="text-[#64748b] mb-6">Associate Professor, Mechanical Engineering Department</p>
            </div>
            <div className="grid gap-4">
              {iitPalakkadCourses.map((course, index) => (
                <Card key={index} className="hover-lift">
                  <CardContent className="p-6 flex items-start gap-4">
                    <div className="bg-blue-50 p-3 rounded-lg">
                      <BookOpen size={24} className="text-[#1e3a8a]" />
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-bold text-[#1e3a8a] mb-1">
                        {course.code}: {course.name}
                      </h4>
                      <p className="text-[#64748b]">{course.years}</p>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </TabsContent>

          <TabsContent value="guwahati">
            <div className="mb-6">
              <h3 className="text-2xl font-bold text-[#1e3a8a] mb-4">IIT Guwahati (May 2017 - Dec 2023)</h3>
              <p className="text-[#64748b] mb-6">Assistant Professor, Mechanical Engineering Department</p>
            </div>
            <div className="grid gap-4">
              {iitGuwahatiCourses.map((course, index) => (
                <Card key={index} className="hover-lift">
                  <CardContent className="p-6 flex items-start gap-4">
                    <div className="bg-blue-50 p-3 rounded-lg">
                      <BookOpen size={24} className="text-[#1e3a8a]" />
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-bold text-[#1e3a8a] mb-1">
                        {course.code}: {course.name}
                      </h4>
                      <p className="text-[#64748b]">{course.years}</p>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
            <div className="mt-8 bg-blue-50 p-6 rounded-lg">
              <h4 className="text-xl font-bold text-[#1e3a8a] mb-3">Teaching Excellence</h4>
              <ul className="space-y-2 text-[#64748b]">
                <li className="flex items-start gap-2">
                  <GraduationCap size={20} className="text-[#1e3a8a] mt-1" />
                  <span>Best Teacher Award for ME-101 (Engineering Mechanics): Jan-May 2019</span>
                </li>
                <li className="flex items-start gap-2">
                  <GraduationCap size={20} className="text-[#1e3a8a] mt-1" />
                  <span>Best Teacher Award for ME-212 (Solid Mechanics-1): July-Nov 2019, 2021</span>
                </li>
              </ul>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default Teaching;